import WRAP from "WRAP-JS";
import { convertWRAPPoint } from "../../../utils/FPEUtils";
import DeferredPromise from "../../../utils/DeferredPromise";

/* eslint-disable */
WRAP.Renderer.GeoJSONExtPopup = function() {
  WRAP.Renderer.GeoJSONExt.call(this);

  var deferredOverlayPromise = new DeferredPromise()

  const superDraw = this.draw;
  this.draw = function(layer, content, conf, context, style, data, revision, dl) {
    WRAP.Geo.check(layer, content, conf, context, style, data, revision, dl);

    //リビジョン & 言語 & timezone 変化チェックを追加
    var noChange = true;
    if ( this.content_revision !== revision.content) {
      noChange = false;
    } else if (this.context_revision !== revision.context) {
      noChange = false;
    } else if (this.conf_revision !== revision.conf) {
      noChange = false;
    } else if (this.style_revision !== revision.style) {
      noChange = false;
    } else if (this.data_revision !== revision.data) {
      noChange = false
    } else if (this.locale !== WRAP.Core.locale) {
      noChange = false
    } else if (this.timeZone !== WRAP.Core.timezone) {
      noChange = false
    }

    if (noChange) {
      return;
    }

    prepareOverlay(data, layer);

    superDraw.apply(this, arguments);

    this.content_revision = revision.content;
    this.context_revision = revision.context;
    this.conf_revision = revision.conf;
    this.style_revision = revision.style;
    this.data_revision = revision.data;
    this.locale = WRAP.Core.locale;
    this.timeZone = WRAP.Core.timezone;

    if ( conf.Attributes.tooltip || conf.Attributes.popup ) {
      var locale = WRAP.Core.locale;
      if (locale != 'ja')
          locale = 'en';
      updateOverlay(data, layer, conf, locale);
    }
  }

  this.clear = function(layer) {
    for ( var e in overlay.listner )
      overlay.interaction.block.removeEventListener(e, overlay.listner[e]);
    for ( var e in overlay.handler )
      WRAP.Geo.removeEventHandler(e, overlay.handler[e]);
    clearOverlay(layer);
    if ( overlay.block && overlay.block.parentNode == overlay.interaction.block )
      overlay.interaction.block.removeChild(overlay.block);
  }

  this._mapping = function(lcale, text, prop, cs, key) {
    return {};
  }

  this.displayWindowWithId = async function(visible, id) {
    await deferredOverlayPromise.promise;
    const display = visible ? 'block' : 'none';
    const popupList = overlay.popup.filter(p => p.id.split('-')[0] == id);
    if (popupList !== undefined) {
      popupList.forEach(p => {
        p.element.style.display = display
      });
    }
  }

  var _this = this;
  var overlay;

  function clearOverlay(layer) {
    var last_overlay = layer.overlay_block;
    if ( last_overlay ) {
      if ( last_overlay.parentNode )
        last_overlay.parentNode.removeChild(last_overlay);
      layer.overlay_block = null;
    }
    overlay = undefined;
  }

  function prepareOverlay(data, layer) {
    if ( layer.overlay_data != data ) {
      layer.overlay_data = data;
      clearOverlay(layer);
    }
  }

  function updateOverlay(data, layer, conf, locale) {
    if ( !overlay )
      layer.overlay_block = initOverlay(layer);
    overlay.conf = conf.Attributes;
    overlay.key = conf.Attributes.key||'id';
    overlay.locale = locale;
    updateWindow();
  }

  function initOverlay(layer) {
    overlay = {
      layer:layer,
      // html
      interaction:layer.view.interaction, // map div
      block:null,
      tooltip:null,
      tooltip_content:null,
      // operation target
      pointer:[-9000,-9000],
      dragging:false,
      drag:[0,0],
      offset:[0,0],
      current_feature:null,
      current_tooltip:null,
      tooltip_range:[],
      // fixed popups
      popup:[],
      popup_index:WRAP.Configuration.overlay.z.point_info_popup,
      tooltip_index:WRAP.Configuration.overlay.z.point_info_tooltip,
    };

    overlay.interaction.block.addEventListener('mousedown', function(event) {
      if (!overlay.layer.visible() || !overlay.current_tooltip) {
        return;
      }
      const mouseDownX = event.clientX;
      const mouseDownY = event.clientY;
      const mouseupHandle = function(ev) {
        overlay.interaction.block.removeEventListener('mouseup', mouseupHandle);
        const mouseUpX = ev.clientX;
        const mouseUpY = ev.clientY;
        const dist = Math.sqrt( Math.pow( mouseUpX-mouseDownX, 2 ) + Math.pow( mouseUpY-mouseDownY, 2 ) );
        //mousedown時とmouseup時のスクリーン座標が10ピクセルより離れていたらクリックではなくドラッグとみなして何もしない
        if (dist > 10) {
          return;
        }
        if ( overlay.current_tooltip && overlay.current_tooltip.geo && !findWindow(overlay.current_tooltip.geo.properties[overlay.key]) ) {
          createWindow(overlay.current_tooltip.geo);
          hideTooltip();
        }
      };
      overlay.interaction.block.addEventListener('mouseup', mouseupHandle);
    });

    overlay.block = document.createElement('div');
    overlay.interaction.block.appendChild(overlay.block);

    overlay.tooltip = document.createElement('div');
    overlay.tooltip.style.zIndex = overlay.tooltip_index;
    overlay.tooltip.style.position = 'absolute';
    overlay.tooltip_content = document.createElement('div');
    overlay.tooltip.appendChild(overlay.tooltip_content);
    overlay.tooltip.style.display = 'none';
    overlay.block.appendChild(overlay.tooltip);

    overlay.listner = {
      mousemove: function(evt) {
        if ( !overlay )
          return;
        var x, y;
        if ( evt.touches ) {
          x = evt.touches[0].pageX;
          y = evt.touches[0].pageY;
        }
        else {
          x = evt.clientX;
          y = evt.clientY;
        }
        if ( overlay.dragging ) {
          // overlay.dragging.style.left = (x-overlay.offset[0]) + 'px';
          // overlay.dragging.style.top = (y-overlay.offset[1]) + 'px';
          for( let i = 0 ; i < overlay.dragging.length ; i ++ ) {
            const elm = overlay.dragging[i];
            elm.style.left = (x - overlay.offset[0]) + 'px';
            elm.style.top = (y - overlay.offset[1]) + 'px';
          }

          hideTooltip();
          //evt.preventDefault();
        }
        var sr = overlay.interaction.block.getBoundingClientRect();
        overlay.pointer[0] = x-sr.left;
        overlay.pointer[1] = y-sr.top;
        //console.log("point "+overlay.pointer[0]+","+overlay.pointer[1]+" offset "+ox+","+oy)
        if ( !overlay.current_feature && !inTooltip({x:overlay.pointer[0], y:overlay.pointer[1]}) ) {
          hideTooltip();
        }
        if (overlay.current_tooltip) {
          const style = overlay.current_tooltip.style();
          if (!style.point) {
            var sr = overlay.interaction.block.getBoundingClientRect();
            var x = overlay.pointer[0] + 10;
            var y = overlay.pointer[1] + 10;
            if (x+overlay.tooltip.clientWidth > sr.width) {
              x = overlay.pointer[0] - overlay.tooltip.clientWidth - 10;
            }
            if (y+overlay.tooltip.clientHeight > sr.height) {
              y = overlay.pointer[1] - overlay.tooltip.clientHeight - 10;
            }
            overlay.tooltip.style.left = x + "px";
            overlay.tooltip.style.top = y + "px";
            overlay.tooltip_range = [x, y, x+overlay.tooltip.clientWidth, y+overlay.tooltip.clientHeight];
          }
        }
      },
      mouseleave: function(evt) {
        hideTooltip();
      }
    }
    for ( var e in overlay.listner )
      overlay.interaction.block.addEventListener(e, overlay.listner[e]);

    overlay.handler = {
      mouseover: function(layer, feature, pos) {
        if ( layer == overlay.layer && feature ) {
          if ( feature.data && feature.data.type == 'label' ) {
            if ( findWindow(feature.data.id) )
              return;
            if ( inTooltip({x:overlay.pointer[0], y:overlay.pointer[1]}) )
              return;
            hideTooltip();
          }
          else if ( feature.geo ) {
            overlay.current_feature = feature;
            if ( inTooltip({x:overlay.pointer[0], y:overlay.pointer[1]}) )
              return;
            showTooltip(feature, pos);
          }
        }
      },
      mouseout: function(layer, feature) {
        if ( layer == overlay.layer ) {
          if ( feature.geo ) {
            overlay.current_feature = null;
            if ( !inTooltip({x:overlay.pointer[0], y:overlay.pointer[1]}) )
              hideTooltip();
          }
        }
      },
      boundsChange: function() {
        hideTooltip();
        var zoom = WRAP.Geo.getZoom();
        if ( overlay.zoom != zoom ) {
          overlay.zoom = zoom;
        }
      },
      visibilityChange: function() {
        if ( !overlay )
          return;
        var d = overlay.layer.visible()?'block':'none';
        for ( var i = 0 ; i < overlay.popup.length ; i++ ) {
          var p = overlay.popup[i];
          var w = p.element;
          w.style.display = d;
        }
        hideTooltip();
      }
    }
    for ( var e in overlay.handler )
        WRAP.Geo.addEventHandler(e, overlay.handler[e]);

    deferredOverlayPromise.resolve()
    return overlay.block;
  }

  function makeIcon(icon, def, hover, active) {
    if ( !hover )
      hover = def;
    if ( !active )
      active = hover;
    icon.src = def;
    icon.onmouseenter = function() {icon.src = hover}
    icon.onmouseout = function() {icon.src = def}
    icon.onmousedown = function() {icon.src = active}
    icon.onmouseup = function() {icon.src = hover}
  }

  function makeTooltipContent(rows, prop) {
    if (typeof _this.makeTooltipContent === 'function') {
      return _this.makeTooltipContent(rows, prop);
    }

    const _rows = Array.isArray(rows) ? rows : rows[prop.type];
    var text = "";
    for ( var i = 0 ; i < _rows.length ; i++ ) {
      var row = _mapping(overlay.locale, _rows[i], prop, overlay.conf.custom);
      if ( _rows[i] == row.text && row.text.split('%').length-1 == 2 )
        continue;
      if ( text.length )
        text += '<br>';
      text+= row.text;
    }
    return text;
  }

  function makeWindowContent(rows, prop) {
    if (typeof _this.makeWindowContent === 'function') {
      return _this.makeWindowContent(rows, prop);
    }

    const _rows = Array.isArray(rows) ? rows : rows[prop.type];
    const content = {
      header: "",
      body: ""
    };
    for ( var i = 0 ; i < _rows.length ; i++ ) {
      var row = _mapping(overlay.locale, _rows[i], prop, overlay.conf.custom);
      if ( _rows[i] == row.text && row.text.split('%').length-1 == 2 )
        continue;
      if ( i === 0 ) {
        content.header = row.value;
      } else {
        if ( content.body.length )
          content.body += '<br>';
        if (!row.key) {
          content.body += row.value;
        } else {
          content.body += `<span style="font-weight: bold">${row.key}</span> : ${row.value}`;
        }
      }
    }
    return content;
  }

  function _mapping(locale, text, prop, cs, key) {
    return _this._mapping(locale, text, prop, cs, key);
  }

  function showTooltip(feature, pos) {
    if ( findWindow(feature.geo.properties[overlay.key]) )
      return;
    for ( var i = 0 ; i < overlay.popup.length ; i++ ) {
      var w = overlay.popup[i].element;
      if ( w.offsetLeft <= pos.x && pos.x < w.offsetLeft+w.offsetWidth
        && w.offsetTop <= pos.y && pos.y < w.offsetTop+w.offsetHeight)
        return;
    }
    var p = overlay.conf.tooltip.padding!==undefined?overlay.conf.tooltip.padding:4;
    var padding = {
      line:p,
      left:overlay.conf.tooltip.padding_left!==undefined?overlay.conf.tooltip.padding_left:p,
      right:overlay.conf.tooltip.padding_right!==undefined?overlay.conf.tooltip.padding_right:p,
      top:overlay.conf.tooltip.padding_top!==undefined?overlay.conf.tooltip.padding_top:p,
      bottom:overlay.conf.tooltip.padding_bottom!==undefined?overlay.conf.tooltip.padding_bottom:p,
    }
    overlay.tooltip_content.innerHTML = makeTooltipContent(overlay.conf.tooltip.text_lines, feature.geo.properties);
    overlay.tooltip.style.cursor = 'default';
    overlay.tooltip.style.userSelect = 'none';
    overlay.tooltip.style.webkitUserSelect = 'none';
    var fontsize = overlay.conf.tooltip.font_size||12;
    overlay.tooltip_content.style.fontSize = fontsize+'px';
    overlay.tooltip_content.style.lineHeight = padding.line+fontsize+'px';
    overlay.tooltip_content.style.whiteSpace = 'nowrap';
    overlay.tooltip_content.style.overflow = 'hidden';
    overlay.tooltip_content.style.textOverflow = 'ellipsis';
    if ( overlay.conf.tooltip.width )
      overlay.tooltip.style.width = overlay.conf.tooltip.width+'px';
    overlay.tooltip.style.backgroundColor = overlay.conf.tooltip.fill_color;
    overlay.tooltip.style.color = overlay.conf.tooltip.text_color;
    overlay.tooltip.style.border = "" + overlay.conf.tooltip.line_width + 'px solid ' + overlay.conf.tooltip.line_color;
    overlay.tooltip.style.display = 'block';
    var sr = overlay.interaction.block.getBoundingClientRect();
    var x = pos.x + 10;
    var y = pos.y + 10;
    if (x+overlay.tooltip.clientWidth > sr.width) {
      x = pos.x - overlay.tooltip.clientWidth - 10;
    }
    if (y+overlay.tooltip.clientHeight > sr.height) {
      y = pos.y - overlay.tooltip.clientHeight - 10;
    }
    overlay.tooltip.style.left = x+'px';
    overlay.tooltip.style.top = y+'px';
    overlay.tooltip.style.paddingLeft = padding.left+'px';
    overlay.tooltip.style.paddingRight = padding.right+'px';
    overlay.tooltip.style.paddingTop = padding.top+'px';
    overlay.tooltip.style.paddingBottom = padding.bottom+'px';
    overlay.tooltip.style.borderRadius = (overlay.conf.tooltip.round_corner||0)+'px';

    overlay.tooltip_range = [x, y, x+overlay.tooltip.clientWidth, y+overlay.tooltip.clientHeight];
    overlay.current_tooltip = feature;
  }

  function hideTooltip() {
    if ( !overlay || !overlay.tooltip )
      return;
    overlay.tooltip_content.innerHTML = "";
    overlay.tooltip.style.display = 'none';
    overlay.current_tooltip = null;
  }

  function inTooltip(pos) {
    if ( !overlay.current_tooltip )
      return false;
    return (overlay.tooltip_range[0]<=pos.x&&pos.x<overlay.tooltip_range[2]
         && overlay.tooltip_range[1]<=pos.y&&pos.y<overlay.tooltip_range[3]);
  }

  function createWindow(geo, offset) {
    var p = overlay.conf.popup.padding!==undefined?overlay.conf.popup.padding:4;
    var padding = {
      line:p,
      left:overlay.conf.popup.padding_left!==undefined?overlay.conf.popup.padding_left:p,
      right:overlay.conf.popup.padding_right!==undefined?overlay.conf.popup.padding_right:p,
      top:overlay.conf.popup.padding_top!==undefined?overlay.conf.popup.padding_top:p,
      bottom:overlay.conf.popup.padding_bottom!==undefined?overlay.conf.popup.padding_bottom:p,
    }

    var w = document.createElement('div');
    w.style.position = 'absolute';
    if ( overlay.conf.popup.width )
      w.style.width = overlay.conf.popup.width+'px';
    w.style.backgroundColor = overlay.conf.popup.fill_color;
    w.style.color = overlay.conf.popup.text_color;
    w.style.border = "" + overlay.conf.popup.line_width + 'px solid ' + overlay.conf.popup.line_color;
    w.style.borderRadius = (overlay.conf.popup.round_corner||0)+'px';
    w.classList.add(geo.properties[overlay.key]);

    const content = makeWindowContent(overlay.conf.popup.text_lines, geo.properties);

    // header
    var header = document.createElement('div');
    header.style.backgroundColor = overlay.conf.popup.title_fill_color || 'rgba(103,93,139,0.7)';
    header.style.color = overlay.conf.popup.title_text_color || '#FFFFFF';
    header.style.height = overlay.conf.popup.title_height || '24px';
    header.style.padding = overlay.conf.popup.title_padding || '0 0 0 10px';
    header.style.fontSize = (overlay.conf.popup.title_font_size || 12) +'px';
    header.style.display = 'flex';
    header.style.alignItems = 'center';
    header.style.cursor = 'move';
    w.appendChild(header);

    const headerText = document.createElement('div');
    w.headerText = headerText;
    w.headerText.innerHTML = content.header;
    header.appendChild(headerText);

    var close_button = new Image();
    makeIcon(close_button, overlay.conf.close_button, overlay.conf.close_button_hover, overlay.conf.close_button_active);
    close_button.style.position = 'absolute';
    close_button.style.top = '2px';
    close_button.style.right = '2px';
    close_button.style.width = '20px';
    close_button.style.height = '20px';
    close_button.style.cursor = 'pointer';
    close_button.addEventListener('mousedown', function(e) {
      hideTooltip();
      overlay.dragging = null;
      e.stopPropagation();
    });
    close_button.onclick = function(ev) {
      hideTooltip();
      deleteWindow(w);
    }
    header.appendChild(close_button);

    //body
    var contentArea = document.createElement('div');
    w.contentArea = contentArea;
    var fontsize = overlay.conf.popup.font_size||12;
    w.contentArea.style.fontSize = fontsize+'px';
    w.contentArea.style.lineHeight = padding.line+fontsize+'px'
    w.contentArea.style.paddingLeft = padding.left+'px';
    w.contentArea.style.paddingRight = padding.right+'px';
    w.contentArea.style.paddingTop = padding.top+'px';
    w.contentArea.style.paddingBottom = padding.bottom+'px';
    var wordWrap = overlay.conf.popup.word_wrap || 'normal';
    w.contentArea.style.wordWrap = wordWrap;

    w.appendChild(contentArea);
    contentArea.innerHTML = content.body;

    header.addEventListener('mousedown', function(evt) {
      overlay.dragging = document.getElementsByClassName(this.parentElement.className);
      overlay.drag[0] = w.style.left.replace(/px/, "");
      overlay.drag[1] = w.style.top.replace(/px/, "");
      overlay.offset[0] = evt.clientX-overlay.drag[0];
      overlay.offset[1] = evt.clientY-overlay.drag[1];
      activateWindow(w);
    });
    header.addEventListener('mouseup', function() {
      overlay.dragging = null;
    });
    header.addEventListener('touchstart', function(evt) {
      if ( evt.touches && evt.touches.length == 1 ) {
        overlay.dragging = this.parentElement;
        overlay.drag[0] = w.style.left.replace(/px/, "");
        overlay.drag[1] = w.style.top.replace(/px/, "");
        overlay.offset[0] = evt.touches[0].pageX-overlay.drag[0];
        overlay.offset[1] = evt.touches[0].pageY-overlay.drag[1];
        activateWindow(w);
      }
    });
    header.addEventListener('touchend', function() {
      overlya.dragging = null;
    });
    overlay.block.appendChild(w);
    var sr = overlay.interaction.block.getBoundingClientRect();
    var sp;
    if (geo.geometry.type === 'Point') {
      sp = WRAP.Geo.getScreenPoint(convertWRAPPoint(geo.geometry.coordinates[1], geo.geometry.coordinates[0]));
    } else {
      sp = {
        x: overlay.pointer[0],
        y: overlay.pointer[1]
      }
    }
    var x = offset ? sp.x+offset[0] : sp.x + 10;
    var y = offset ? sp.y+offset[1] : sp.y + 10;
    if (x+w.clientWidth > sr.width) {
      x = sp.x - w.clientWidth - 10;
    }
    if (y+w.clientHeight > sr.height) {
      y = sp.y - w.clientHeight - 10;
    }
    w.style.left = x+'px';
    w.style.top = y+'px';
    overlay.popup.push({id:geo.properties[overlay.key], point:geo.geometry.coordinates, prop:geo.properties, element:w});
    WRAP.Geo.redraw(overlay.layer);
    activateWindow(w);
  }

  function findWindow(id) {
    for ( var i = 0 ; i < overlay.popup.length ; i++ ) {
      if ( overlay.popup[i].id == id )
        return overlay.popup[i].element;
    }
  }

  function activateWindow(w) {
    for ( var i = 0 ; i < overlay.popup.length ; i++ ) {
      if ( overlay.popup[i].element == w ) {
        var p = overlay.popup[i];
        overlay.popup.splice(i, 1);
        overlay.popup.push(p);
        while ( i < overlay.popup.length ) {
          overlay.popup[i].element.style.zIndex = overlay.popup_index+i;
          i++;
        }
        return;
      }
    }
  }

  function updateWindow() {
    for ( var i = 0 ; i < overlay.popup.length ; i++ ) {
      var p = overlay.popup[i];
      var w = p.element;
      const content = makeWindowContent(overlay.conf.popup.text_lines, p.prop);
      w.headerText.innerHTML = content.header;
      w.contentArea.innerHTML = content.body;
    }
  }

  function deleteWindow(w) {
    for ( var i = 0 ; i < overlay.popup.length ; i++ ) {
      if ( overlay.popup[i].element == w ) {
        overlay.popup.splice(i, 1);
        overlay.block.removeChild(w);
        WRAP.Geo.redraw(overlay.layer);
        return;
      }
    }
  }
};
/* eslint-enable */
